<template>
  <div>
    <navigationBar :fill="true" />
    <div class="width-1200">
      <breadcrumb />
      <loading
        :loading="loadings"
        background="transparent"
        color="#c4332e"
        style="z-index: 120"
      ></loading>
      <div class="search-box flx-row-s-c">
        <Input
          v-model.trim="search"
          clearable
          placeholder="请输入域名信息"
          maxlength="30"
          @on-keyup="change"
          @on-enter="searchEvnet"
        />

        <div
          class="search-button"
          style="margin-left: 30px"
          @click="searchEvnet"
        >
          <img src="@/assets/image/seach-icon.png" alt="" />
          <span>查询</span>
        </div>
      </div>

      <div
        v-if="!noData && !noResult"
        class="content-box"
        style="margin-top: 100px"
      >
        <div class="whios-title">
          域名
          <span style="color: #c4332e; font-size: 30px">{{
            info.domainName
          }}</span>
          注册信息
          <span style="float: right; cursor: pointer" @click="refreshWhois">获取最新信息</span>
        </div>
        <div style="margin-top: 16px">
          <div class="info-item" style="margin-top: 16px">
            <div class="info-title">域名:</div>
            <div class="info-text">{{ info.domainName }}</div>
          </div>
          <div class="info-item">
            <div class="info-title">域名状态:</div>
            <div class="info-text">
              <p v-for="item in info.status" :key="item">
                {{ item }}
              </p>
            </div>
          </div>
          <div class="info-item">
            <div class="info-title">注册联系电话:</div>
            <div class="info-text">{{ info.telphone }}</div>
          </div>
          <div class="info-item">
            <div class="info-title">注册者联系电子邮箱:</div>
            <div class="info-text">{{ info.mail }}</div>
          </div>
          <div class="info-item">
            <div class="info-title">注册商:</div>
            <div class="info-text">{{ info.registrar }}</div>
          </div>
          <div class="info-item">
            <div class="info-title">DNS服务器:</div>
            <div class="info-text">
              <p v-for="(item, index) in info.dns" :key="item">
                DNS{{ index + 1 }}：{{ item }}
              </p>
              <p v-if="info.dns.length === 0">暂无数据</p>
            </div>
          </div>
          <div class="info-item">
            <div class="info-title">注册日期:</div>
            <div class="info-text">{{ info.registrationDateTime }}</div>
          </div>
          <div class="info-item">
            <div class="info-title">过期时间:</div>
            <div class="info-text">{{ info.expirationDateTime }}</div>
          </div>
        </div>
      </div>

      <div
        v-if="!noData && !noResult"
        class="content-box"
        style="margin-top: 20px"
      >
        <div class="whios-title">
          <span class="title-inner">详细英文注册信息</span>
        </div>
        <div class="content" v-html="info.details || ''"></div>
      </div>

      <div
        v-if="noData"
        class="content-box"
        style="line-height: 80px; font-size: 18px; margin-top: 100px"
      >
        <span>“{{ search }}”</span>未查询到whois信息<span
          style="color: #c4332e; margin-left: 5px; cursor: pointer"
          @click="toRegister(search)"
        >
          >> 立即注册</span
        >
      </div>

      <div v-if="noResult" class="content-box" style="margin-top: 100px">
        <div style="font-size: 20px">未查询到whois信息</div>
        <div style="font-size: 14px; margin-top: 10px">
          该域名可能被注册局保留、正在审核或限制注册，暂无whois信息
        </div>
      </div>
      <footBar />
    </div>
    <captcha ref="childCaptcha" @custom-event="getCodeEvent"></captcha>
  </div>
</template>

<script>
import navigationBar from "components/navigationBar.vue";
import footBar from "components/footBar.vue";
import breadcrumb from "components/breadcrumb.vue";
import loading from "components/loading.vue";
import { getCaptchaWhoisV1, getCaptchaWhoisV2 } from "api/domain";
import captcha from "components/captcha.vue";
const domain =
  // eslint-disable-next-line max-len
  /[^.]+\.(top|com.cn|com|cn|xyz|club|中国|网址|work|vip|beer|在线|net.cn|tv|org.cn|org|name|cc|中文网|info|pro|red|网店|net|yoga|fashion|luxe|love|kim|blue|pet|pink|移动|ski|ltd|chat|group|pub|run|city|live|ink|wiki|design|email|company|plus|video|center|cool|fund|gold|guru|life|show|team|today|world|zone|social|网站|bio|black|green|lotto|organic|poker|promo|vote|archi|voto|online|site|store|tech|fun|space|host|press|wang|商店|企业|娱乐|游戏|fit|icu|art|website|asia|我爱你|集团|biz|games|tax|studio|shopping|media|cash|fyi|vin|sale|mba|band|cab|fan|news|cafe|technology|market|fans|ren|cloud|co|shop|law|link|ac.cn|bj.cn|tj.cn|sh.cn|cq.cn|he.cn|ha.cn|sx.cn|nm.cn|ln.cn|jl.cn|hl.cn|js.cn|zj.cn|ah.cn|fj.cn|jx.cn|sd.cn|hb.cn|hn.cn|gd.cn|gx.cn|hi.cn|sc.cn|gz.cn|yn.cn|xz.cn|sn.cn|gs.cn|qh.cn|nx.cn|xj.cn|tw.cn|hk.cn|mo.cn)/;

export default {
  name: "whois",
  components: {
    navigationBar,
    footBar,
    breadcrumb,
    loading,
    captcha
  },
  data() {
    return {
      showNav: false,
      loadings: false,
      search: "",
      info: {
        details: "",
        dns: [],
        name: "",
        contactMail: "",
        endDateTime: "",
        contactPhone: "",
        registrar: "",
        registrationTime: "",
        status: [],
      },

      // 没有数据
      noData: false,
      // 没有结果
      noResult: false,
    };
  },
  mounted() {
    this.search = this.$route.query.key.toLowerCase() || "";
    if (!this.search) {
      this.$Message.warning("请输入查询的域名信息！");
      this.loadings = false;
      return false;
    }
    // 获取最后一个带点的数据
    const temp = this.search.match(domain);
    if (temp && temp.length > 0) {
      this.search = temp[0];
    } else {
      this.$Message.warning("请输入正确域名信息！");
      return false;
    }
    this.init();
  },
  methods: {
    refreshWhois() {
      this.$refs.childCaptcha.onShow()
    },
    async getCodeEvent(obj) {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV2(this.search, obj.id, obj.code);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.flag === 0;
          this.noResult = data.flag === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    change() {
      this.search = this.search.replace(/\s+/g, "");
    },
    // 初始化
    async init() {
      try {
        this.loadings = true;
        const { code, data } = await getCaptchaWhoisV1(this.search);

        this.loadings = false;
        if (code === 200) {
          this.info = data;
          this.info.details = data.details.replace(/\n/g, "<br/>");
          if (this.info.status) {
            this.info.status = data.status.split(",");
          } else {
            this.info.status = [];
          }

          if (this.info.dns) {
            this.info.dns = data.dns.split(",");
          } else {
            this.info.dns = [];
          }

          this.noData = data.flag === 0;
          this.noResult = data.flag === 2;
        } else {
          this.noData = true;
          this.noResult = false;
        }
      } catch (error) {
        this.loadings = false;
        this.$Message.warning(error);
      }
    },
    // 搜索
    searchEvnet() {
      if (!this.search) {
        this.$Message.warning("请输入查询的域名信息！");
        return false;
      }

      // 获取最后一个带点的数据
      const temp = this.search.match(domain);
      if (temp && temp.length > 0) {
        this.search = temp[0];
      } else {
        this.$Message.warning("请输入正确域名信息！");
        return false;
      }
      this.$nextTick(() => {
        history.pushState("", "", `/whois?key=${this.search}`);
        this.init();
      });
    },
    toRegister(name) {
      let newName = name.substring(0, name.indexOf("."));
      window.open(`/search?name=${newName}`, "_blank");
    },
  },
};
</script>



<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  .search-button {
    cursor: pointer;
    width: 132px;
    height: 64px;
    color: #fff;
    background: #c4332e;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    img {
      width: 21px;
      height: 21px;
      margin-right: 15px;
    }
  }
}
.content-box {
  min-height: 100px;
  background: #FFFFFF;
  color: #333333;
  border: 1px solid #E9E9E9;
  border-radius: 25px;
  padding: 20px 38px;
  .whios-title {
    font-weight: Bold;
    padding-bottom: 20px;
    border-bottom: 1px solid #eeeeee;
    .title-inner {
      border-bottom: 3px solid #d2d2d2;
      padding-bottom: 20px;
    }
  }
  .info-item {
    display: flex;
    line-height: 36px;
    .info-title {
      min-width: 130px;
      text-align: right;
      color: #d8d8d8;
      margin-right: 16px;
    }
  }
  .content {
    margin-top: 30px;
    color: #d8d8d8;
    line-height: 28px;
  }
}
/deep/ .ivu-input-wrapper {
  width: 800px;
}
/deep/ .ivu-input {
  height: 64px;
}
/deep/ .ivu-input-icon {
  line-height: 64px;
}
</style>
